import { render, staticRenderFns } from "./CRPageModal.vue?vue&type=template&id=bce9323c&scoped=true&"
import script from "./CRPageModal.vue?vue&type=script&lang=js&"
export * from "./CRPageModal.vue?vue&type=script&lang=js&"
import style0 from "./CRPageModal.vue?vue&type=style&index=0&id=bce9323c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce9323c",
  null
  
)

export default component.exports